import moment from "moment";
export default{
	securityToken: function(state) {
		return "BEARER " + state.userid + " " + state.accessToken;
	},
	isLoading: function(state) {
		return state.loading
	},
	isLoggedIn: function(state) {
		return state.isLoggedIn
	},
	unsubscribedPage: function(state) {
		let pagelist = []

		$.each(state.pagelist,function(page_index,page_value){
			let isFound = false
			$.each(state.botlist,function(bot_index,bot_value){
				if (bot_value.pageid == page_value.id) {
					isFound = true
					return false
				}
			})

			if (!isFound) {
				pagelist.push(page_value)
			}
		})

		return pagelist
	},
	selectedBot: function(state) {
		return state.selectedBot
	},
	botlist: function(state) {
		return state.botlist
	},
	isSelectedBot: function(state) {
		return state.isSelectedBot
	},
	paypalTrackingId: function(state){
		return state.paypalTrackingId
	},
	setting: function (state){
		return state.setting
	}, 
	welcomeMessage: function (state) {
		return state.welcomeMessage
	},
	showModalWelcome: function(state){
		return state.showModalWelcome
	}, 
	isFacebook: function (state) {
		return state.isFacebook
	},
	getPackage: function(state){
		var now = moment();
		var date = moment(state.selectedBot.expireat);
		var expriedTime = parseInt(date.diff(now, 'seconds'))
		return (expriedTime > 0) ? 'premium' : 'normal';
	}

}



// WEBPACK FOOTER //
// ./src/store/getters.js